const defaultProps = {
  schemas: [],
};

function OutputRelation({ field, object }) {
  const relation = object[field];
  if (!Array.isArray(relation)) return null;

  if (relation && field === "payrollRelation") {
    return relation.flatMap((entry, i) => {
      const { classification } = entry || {};
      if (!classification) return [];

      const items = Array.isArray(classification)
        ? classification
        : [classification];

      return items
        .filter(Boolean)
        .map(({ earnings, payrollType } = {}, j) => (
          <div key={`${i}-${j}`} className="d-flex align-items-center gap-1">
            &#8226;&nbsp;
            {earnings}
            <i className="bi bi-arrow-right-short" />
            {payrollType}
          </div>
        ));
    });
  }

  if (relation && field === "assignRelation") {
    return relation.map(({ employee }, i) => (
      <div key={`${i}`} className="d-flex align-items-center gap-1">
        &#8226;&nbsp;
        {`${employee?.surname?.toUpperCase() || ""}, ${
          employee?.Firstname?.toUpperCase() || ""
        } ${employee?.Middlename?.toUpperCase() || ""}`}
      </div>
    ));
  }

  return null;
}

OutputRelation.defaultProps = defaultProps;
export default OutputRelation;
